angular.module("app").directive("pricingCard",[ "paymentService", "localStorageService", "modalService", (paymentService, localStorageService, modalService) => {
  let link = (scope) => {
    scope.getActive = (item) => {
      if(scope.isAnnuallyMode) {
        if(item.type === 'pro' && scope.currentUserPlan && scope.currentUserPlan.name === 'pro-yearly') {
          return true;
        } else if(item.type === 'teams' && scope.currentUserPlan && scope.currentUserPlan.name === 'team-yearly') {
          return true;
        }
      } else {
        if(item.type === 'pro' && scope.currentUserPlan && scope.currentUserPlan.name === 'pro-monthly') {
          return true;
        } else if(item.type === 'teams' && scope.currentUserPlan && scope.currentUserPlan.name === 'team-monthly') {
          return true;
        }
      }
    }
    scope.showCardModal = false;
    scope.upgradePlanDetails = undefined;
    scope.isSubscribing = false;

    scope.$watch("isAnnuallyMode", function (mode) {
      scope.isAnnuallyMode = mode;
    });

    scope.$watch("currentUserPlan", function (currentUserPlan) {
      scope.currentUserPlan = currentUserPlan;
    });
    
    scope.$watch("isSource", function (isSource) {
      scope.isSource = isSource;
    });

    scope.getInteger = (value) => {
      return Math.floor(value);
    };

    scope.getDecimal = (value) => {
      const res = Math.round((value - Math.floor(value)) * 100);

      return res ? res : '';
    };
  
    scope.joinNow =(data) => {
      if(scope.isSubscribing) { return; }
      if(!(data.type === 'pro' || data.type === 'teams')) {return;}
      scope.isSubscribing = true;
      let planPrice;

      if(data.type === 'pro' && scope.isAnnuallyMode){
        planPrice = data.yearlyId;
      } else if(data.type === 'pro' && !scope.isAnnuallyMode){
        planPrice = data.monthlyId;
      } else if(data.type === 'teams' && scope.isAnnuallyMode){
        planPrice =  data.yearlyId;
      } else if(data.type === 'teams' && !scope.isAnnuallyMode){
        planPrice = data.monthlyId;
      }
      var stripe = Stripe(scope.stripePubKey);
      const params = {
        plan_id: planPrice,
        quantity: data.type === 'teams' ? 2 : 1
      }
      paymentService.createSubscription(params).then((data) => {
        if(data && data.stripe && data.stripe.id) {
          stripe.redirectToCheckout({
            sessionId: data.stripe.id
          }).then(function (result) {
            if(result && result.error) {
              scope.isSubscribing = false;
              modalService.showModal(9, null, result.error.message);
            }
          });
        } else {
          scope.isSubscribing = false;
          modalService.showModal(9, null, (data && data.message) ? data.message : "Unable to initiate checkout");
        }
      }).catch((err) => {
        scope.isSubscribing = false;
        const msg = (err && err.data && err.data.message) ? err.data.message : "Error initiating checkout";
        modalService.showModal(9, null, msg);
      });
    }

    scope.joinNowTeam =(data) => {
      if(scope.isSubscribing) { return; }
      if(!(data.type === 'pro' || data.type === 'teams')) {return;}
      scope.isSubscribing = true;
      let planPrice;

      if(data.type === 'pro' && scope.isAnnuallyMode){
        planPrice = data.yearlyId;
      } else if(data.type === 'pro' && !scope.isAnnuallyMode){
        planPrice = data.monthlyId;
      } else if(data.type === 'teams' && scope.isAnnuallyMode){
        planPrice =  data.yearlyId;
      } else if(data.type === 'teams' && !scope.isAnnuallyMode){
        planPrice = data.monthlyId;
      }
      var stripe = Stripe(scope.stripePubKey);
      const params = {
        plan_id: planPrice,
        quantity: data.type === 'teams' ? 2 : 1
      }
      paymentService.joinSubscription(params).then((data) => {
        if(data && data.stripe && data.stripe.id) {
          stripe.redirectToCheckout({
            sessionId: data.stripe.id
          }).then(function (result) {
            if(result && result.error) {
              scope.isSubscribing = false;
              modalService.showModal(9, null, result.error.message);
            }
          });
        } else {
          scope.isSubscribing = false;
          modalService.showModal(9, null, (data && data.message) ? data.message : "Unable to initiate checkout");
        }
      }).catch((err) => {
        scope.isSubscribing = false;
        const msg = (err && err.data && err.data.message) ? err.data.message : "Error initiating checkout";
        modalService.showModal(9, null, msg);
      });
    }

    scope.upgradePlanFree =(data) => {
      if(scope.isSubscribing) { return; }
      if(!(data.type === 'free')) {return;}
      scope.isSubscribing = true;
      let planPrice;
      if(data.type === 'free' && scope.isAnnuallyMode){
        planPrice =  data.yearlyId;
      } else if(data.type === 'free' && !scope.isAnnuallyMode){
        planPrice = data.monthlyId;
      }
      const params = {
        plan_id: planPrice
      }
      paymentService.joinSubscription(params).then((data) => {
        scope.isSubscribing = false;
        setTimeout(() => {
          scope.getCurrentPlan();
        }, 500);
        if(data.success === 'ok') {
          modalService.showModal(9, null, data.message);
        }
      }).catch((err) => {
        scope.isSubscribing = false;
        const msg = (err && err.data && err.data.message) ? err.data.message : "Error updating plan";
        modalService.showModal(9, null, msg);
      });
    }

    scope.upgradePlan =(data) => {
      if(scope.isSubscribing) { return; }
      if(!(data.type === 'pro' || data.type === 'teams' || data.type === 'free')) {return;}
      if(!scope.isSource) {
        scope.showCardModal = true;
        scope.upgradePlanDetails = data;
      } else {
        scope.isSubscribing = true;
        let planPrice;
        if(data.type === 'pro' && scope.isAnnuallyMode){
          planPrice = data.yearlyId;
        } else if(data.type === 'pro' && !scope.isAnnuallyMode){
          planPrice = data.monthlyId;
        } else if(data.type === 'teams' && scope.isAnnuallyMode){
          planPrice =  data.yearlyId;
        } else if(data.type === 'teams' && !scope.isAnnuallyMode){
          planPrice = data.monthlyId;
        } else if(data.type === 'free' && scope.isAnnuallyMode){
          planPrice =  data.yearlyId;
        } else if(data.type === 'free' && !scope.isAnnuallyMode){
          planPrice = data.monthlyId;
        }
        const params = {
          plan_id: planPrice
        }
        paymentService.upgradeSubscription(params).then((data) => {
          scope.isSubscribing = false;
          setTimeout(() => {
            scope.getCurrentPlan();
          }, 500);
          if(data.success === 'ok') {
            modalService.showModal(9, null, data.message);
          }
        }).catch((err) => {
          scope.isSubscribing = false;
          const msg = (err && err.data && err.data.message) ? err.data.message : "Error upgrading plan";
          modalService.showModal(9, null, msg);
        });
      }
    }

    scope.getUpgratePlanData = (token) => {
      let planPrice;
      if(scope.upgradePlanDetails.type === 'pro' && scope.isAnnuallyMode){
        planPrice = scope.upgradePlanDetails.yearlyId;
      } else if(scope.upgradePlanDetails.type === 'pro' && !scope.isAnnuallyMode){
        planPrice = scope.upgradePlanDetails.monthlyId;
      } else if(scope.upgradePlanDetails.type === 'teams' && scope.isAnnuallyMode){
        planPrice =  scope.upgradePlanDetails.yearlyId;
      } else if(scope.upgradePlanDetails.type === 'teams' && !scope.isAnnuallyMode){
        planPrice = scope.upgradePlanDetails.monthlyId;
      } else if(scope.upgradePlanDetails.type === 'free' && scope.isAnnuallyMode){
        planPrice =  scope.upgradePlanDetails.yearlyId;
      } else if(scope.upgradePlanDetails.type === 'free' && !scope.isAnnuallyMode){
        planPrice = scope.upgradePlanDetails.monthlyId;
      }
      const params = {
        plan_id: planPrice,
        source: token
      }

      paymentService.upgradeSubscription(params).then((data) => {
        scope.showCardModal = false;
        setTimeout(() => {
          scope.getCurrentPlan();
        }, 500);
        if(data.success === 'ok') {
          modalService.showModal(9, null, data.message);
        }
      });
    }

    scope.toggleSignUpDetails = (item) => {
      scope.toggleSignUp(item);
    }

    scope.toggleCardDetails = function(item) {
      scope.showCardModal = false;
    };
  };

  return {
    restrict: "E",
    templateUrl: "app/directives/pricingCard/pricingCardView.html",
    link: link,
    scope: {
      data: "=",
      isAnnuallyMode: "=",
      toggleSignUp: "=",
      stripePubKey: "=",
      planPrices: "=",
      currentUserPlan: "=",
      getCurrentPlan: "=",
      isSource: "="
    }
  };
},
]);
